"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemoryStorage = require("memorystorage");
exports.myStorage = function () {
    if (typeof window !== 'undefined') {
        var KEY = "my_storage_supported_" + Math.random();
        try {
            window.localStorage.setItem(KEY, 'true');
            if (window.localStorage.getItem(KEY) !== 'true') {
                throw new Error('Unable to use `window.localStorage`.');
            }
            window.localStorage.removeItem(KEY);
            return window.localStorage;
        }
        catch (err) {
            return new MemoryStorage();
        }
    }
    return new MemoryStorage();
};
exports.default = exports.myStorage();
//# sourceMappingURL=storage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/storage/storage.js
// module id = 1173
// module chunks = 0